import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "../Pages/SideMenu";
import Footer from "../Pages/Footer";
import Header from "../Pages/Header";
import Logout from "../Pages/Logout";
import { strings } from "../Utilities/strings";
import Search from "../images/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from "react-multi-select-component";

import {
  faEdit,
  faTrash,
  faPlus,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import searchIcon from "../images/search_icon.svg";


//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import {
  FarmOperationRMHistoryAll,
  RmhistoryGet,
  FarmOperation_getMasters,
} from "../Utilities/URLCONSTANTS";
import Loader from "../Utilities/Loader";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import * as XLSX from "xlsx";
import moment from "moment";
import { CustomDatePickerInput, customstyles } from "../../src/Utilities/utils";
import Select from "react-select";
// import searchIcon from "../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
// import Add_Icon from "../images/Add_Icon.svg";
import Eye_Icon from "../images/Eye_Icon.svg";
import Pagination from "../Utilities/Pagination";

//UnitMeasureMaster
const FarmOperationHistory = ({ }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Unit Measure Master"
  );
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [ActivityData, setActivityData] = useState([]);
  const [selectedMachine, setSelectedOption] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [machineSelecetdOptions, setMachineSelectedOptions] = useState("");

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const toggleDetails = (index) => {
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  const fetchTypeOfOperationDropdownData = async () => {
    const apiUrl = FarmOperation_getMasters;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("responseLocation", response);
        setActivityData(response.data.response.rmActivitiesMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  // const totalItems = data.length;

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handleModalOpen = () => {
    setSelectedOption("");
    setSelectedStartDate("");
    setSelectedEndDate("");
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    window.location.reload();
  };

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };
  const closeWarning = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (data != null && data != undefined) {
      setFilteredData(data);
      setTotalItems(data.length);
      setIsLoading(false);
    }
  }, [data]);

  const fetchData = async () => {
    // debugger;
    const apiUrl = FarmOperationRMHistoryAll;
    const headers = await GetApiHeaders();
    console.log("Dynamic Headers::", headers);
    setIsLoading(true);
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        // debugger;
        setIsLoading(false);
        setData(response.data.response.rmHistory);
        const respData = response.data.response.rmHistory;
        const activityType = [
          ...new Set(respData.map((item) => item.activityType)),
        ];
        setActivityData(activityType);
        setLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
    // }, 900);
  };

  useEffect(() => {
    fetchData();
    fetchTypeOfOperationDropdownData();
  }, []);



  const handleChange = (machineSelecetdOptions, name, value) => {
    if (name === "selectedStartDate") {
      setSelectedStartDate(value);
    } else if (name === "selectedEndDate") {
      setSelectedEndDate(value);
    } else {
      const labelNames = machineSelecetdOptions.map((item) => item.label).join(", ");
      setSelectedOption(machineSelecetdOptions);
      setMachineSelectedOptions(labelNames);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    const reqObj = {
      activityType: machineSelecetdOptions,
      // startDate: selectedStartDate,
      // endDate: selectedEndDate,
      startDate: formatDate(selectedStartDate),
      endDate: formatDate(selectedEndDate),

    };
    const apiUrl = RmhistoryGet;
    const headers = await GetApiHeaders();
    console.log("Dynamic Headers::", headers);
    setIsLoading(true);
    axios.post(apiUrl, reqObj, { headers }).then((response) => {
      setData(response.data.response.rmHistory);
      setShowModal(false);
    });
  };

  function extractTimeFromDate(dateTimeString) {
    const dateObject = new Date(dateTimeString);
    const timeOnly = dateObject.toLocaleTimeString("en-US", { hour12: true });
    return timeOnly;
  }

  function resetData(event) {
    event.preventDefault();
    setSelectedOption("");
    setStartDate(null);
    setEndDate(null);
    fetchData();
  }

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) =>
          item.activityType.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.service.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.requiredDate.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filteredResults);
    }
  };

  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Machines / Systems",
        "Service",
        "Submitted Date",
        "Submitted Time",
        "Remarks",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item, index) => [
        index + 1,
        item.activityType,
        item.service,
        item.requiredDate,
        extractTimeFromDate(item.submittedDate),
        item.remarks,
      ]),
    ];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FO-RMHistory");
    // Save the file
    XLSX.writeFile(wb, "FO-RMHistory.xlsx");
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Check if values are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }

      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });
  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} style={{ cursor: "pointer" }} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} style={{ cursor: "pointer" }} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} style={{ cursor: "pointer" }} />
    );
  };

  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0" id="farmOperations">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">Farm Operations</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mt-0 Sub_role_text">R&M History</h6>
                      </div>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div className="card p-3">
                      <form onSubmit={handleSubmit}>
                        <div className="d-flex">
                          <div className="col-md-3 col-12">
                            <label className="form-label  font-weight-bold "
                              style={{ marginTop: "-7px" }} >
                              Type Of Operation
                              <span style={{ color: "red" }}>*</span>{" "}
                            </label>
                            <MultiSelect
                              options={ActivityData.map((item) => ({
                                label: item.name,
                                value: item.code,
                              }))}
                              value={selectedMachine}
                              onChange={handleChange}
                              labelledBy="Select"
                              overrideStrings={{
                                selectSomeItems:
                                  "Select Type Of Operations",
                              }}
                              renderValue={(selected) => (
                                <div>
                                  {selected?.map(
                                    (selectedItem, index) => (
                                      <span key={index}>
                                        {selectedItem?.code}
                                      </span>
                                    )
                                  )}
                                </div>
                              )}
                            />
                          </div>

                          <div className="col-md-3 col-12  mb-4">
                            <label
                              for="exampleInputPassword1"
                              //class="form-label mb-0 pb-2"
                              className="form-label  font-weight-bold mb-0 pb-2 "
                            >
                              Start Date
                            </label>
                            <div
                              className="input-group input-group w-100"
                            >
                              <DatePicker
                                showIcon
                                className="form-control w-100"
                                placeholderText="Select Start Date"
                                // selected={startDate}
                                selected={selectedStartDate}
                                onChange={(date) => setSelectedStartDate(date)}
                                dateFormat="dd/MM/yyyy"
                                customInput={<CustomDatePickerInput />}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 col-12  mb-4">
                            <label
                              for="exampleInputPassword1"
                              //class="form-label mb-0 pb-2"
                              className="form-label  font-weight-bold mb-0 pb-2 "
                            >
                              End Date
                            </label>
                            <div>
                              <DatePicker
                                showIcon
                                className="form-control w-100"
                                placeholderText="Select End Date"
                                // selected={endDate}
                                selected={selectedEndDate}
                                onChange={(date) => setSelectedEndDate(date)}
                                dateFormat="dd/MM/yyyy"
                                minDate={startDate}
                                customInput={<CustomDatePickerInput />}
                              />
                            </div>
                            <div>

                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-center mt-4 mb-4">
                          <Button variant="primary" type="submit"
                            className="buttons ml-2 mr-2 "
                          >
                            Search
                          </Button>
                          <Button
                            className="buttons ml-2 mr-2 "
                            variant="danger"
                            onClick={resetData}
                          >
                            Clear All
                          </Button>
                        </div>
                      </form>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div className="card data_tableCard">
                      <div className="card-body">
                        <div className="my-2 d-flex justify-content-between align-items-center flex-wrap">

                          {/* Left Side - Show Entries */}
                          <div className="d-flex align-items-center">
                            <label className="mr-1 mb-0">Show</label>
                            <Select
                              options={[
                                { value: 10, label: '10' },
                                { value: 20, label: '20' },
                                { value: 50, label: '50' },
                              ]}
                              value={{
                                value: itemsPerPage,
                                label: String(itemsPerPage),
                              }}
                              onChange={(selected) => {
                                setItemsPerPage(selected.value);
                                setCurrentPage(1);
                              }}
                              isSearchable={false}
                              styles={customstyles}
                            />
                            &nbsp;
                            <label className="mb-0">Entries</label>
                          </div>

                          {/* Right Side - Search and Download */}
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <div className="position-relative d-inline-block">
                              <img
                                src={searchIcon}
                                alt="Search"
                                className="search-icon"
                              />
                              <input
                                type="text"
                                placeholder="Type to Search..."
                                value={searchTerm}
                                onChange={(e) => handleFilter(e.target.value)}
                                className="form-control search-input"
                              />

                              {searchTerm && (
                                <button
                                  type="button"
                                  className="search-clear-btn"
                                  onClick={() => handleFilter("")}
                                >
                                  ×
                                </button>
                              )}

                            </div>
                            <button
                              className="btn btn-secondary buttons-excel buttons-html5 "
                              style={{
                                marginTop: "4px",
                              }}
                              onClick={exportToExcel}
                            >
                              Download Excel
                            </button>
                          </div>

                        </div>

                        <Table className="table table-bordered Content_data_table table-striped">
                          {/* Existing table code */}
                          <Table
                            className="table table-bordered Content_data_table table-striped"
                          >
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("activityType")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Machines / Systems
                                    {renderSortIcon("activityType")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("service")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Service
                                    {renderSortIcon("service")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("submittedDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Submitted Date
                                    {renderSortIcon("submittedDate")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("submittedDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Submitted Time
                                    {renderSortIcon("submittedDate")}
                                  </span>
                                </Th>

                                <Th className="text-left">View</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {currentItems !== undefined &&
                                currentItems !== null &&
                                currentItems.map((item, index) => {
                                  var parsedDate = moment(item.requiredDate, "DD-MM-YYYY");
                                  var newDateFormat = parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
                                  var submittedDate = moment(item.submittedDate).format("DD-MMM-YYYY")
                                  return (
                                    <React.Fragment >
                                      <Tr>
                                        <Td className="text-center" >
                                          {" "}
                                          {(currentPage - 1) * itemsPerPage + index + 1}
                                        </Td>
                                        <Td className="text-left">
                                          {" "}
                                          {item.activityType}{" "}
                                        </Td>
                                        <Td className="text-left">
                                          {" "}
                                          {item.service}{" "}
                                        </Td>
                                        <Td className="text-left">
                                          {" "}
                                          {submittedDate}{" "}
                                        </Td>
                                        <Td className="text-left">
                                          {" "}
                                          {extractTimeFromDate(
                                            item.submittedDate
                                          )}{" "}
                                        </Td>
                                        <Td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div>
                                            <img
                                              src={Eye_Icon}
                                              alt="Details"
                                              className="eyeicon mr-2"
                                              title="Details"
                                              onClick={() => toggleDetails(index)}
                                            />
                                          </div>
                                        </Td>
                                      </Tr>
                                      {selectedRowIndex === index && (
                                        <Tr>
                                          <Td colSpan="8">
                                            <div className="request-card ">
                                              <div
                                                style={{ fontSize: 14, width: "100%", }}
                                                className="ProductNameForRandM d-flex"
                                              >
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Requester Name
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.requesterName}</span>
                                                </span>
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', textAlign: "center", fontWeight: 600 }} >
                                                    Requester Mobile
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.requesterMobileNumber}</span>
                                                </span>
                                              </div>

                                              <div
                                                style={{ fontSize: 14, width: "100%", }}
                                                className="ProductNameForRandM d-flex mt-3"
                                              >
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Request ID
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.serverRequestId}</span>
                                                </span>
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', textAlign: "center", fontWeight: 600 }} >
                                                    Location
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.locationName}</span>
                                                </span>

                                              </div>
                                              <div style={{ fontSize: 14, width: "100%", }}
                                                className="ProductNameForRandM d-flex mt-3" >
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Cost
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.cost}</span>
                                                </span>

                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', textAlign: "center", fontWeight: 600 }} >
                                                    Services
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.service}</span>
                                                </span>
                                              </div>

                                              <div style={{ fontSize: 14, width: "100%", }}
                                                className="ProductNameForRandM d-flex mt-3" >
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Remarks
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces", }}>{item.remarks}</span>
                                                </span>
                                              </div>
                                            </div>
                                          </Td>
                                        </Tr>
                                      )}
                                    </React.Fragment>
                                  );
                                })}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                        </Table>

                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />
                      </div>
                    </div>
                  </div>
                  {loading && (
                    <div>
                      <p>Fetching data. Please wait...</p>
                      <Loader
                        height="80"
                        width="80"
                        radius="9"
                        color="#4A7729"
                        ariaLabel="loading"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default FarmOperationHistory;
